import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../BasicComponents/UserContext';

/**
 * TenantStudentAuthGuard
 *
 * Protects tenant student routes. Redirects to /student/login
 * if no authenticated session is found in localStorage.
 *
 * This component is ONLY rendered inside tenant subdomain routes
 * (routes.jsx already gates by isTenantSubdomain()), so no
 * additional domain check is needed here.
 */
const TenantStudentAuthGuard = ({ children }) => {
  const { user } = useContext(UserContext);
  const sessionToken = localStorage.getItem('session_token');

  if (!user || !sessionToken) {
    return <Navigate to="/student/login" replace />;
  }

  return <>{children}</>;
};

export default TenantStudentAuthGuard;
